import Tools from "../../../../components/common/tools/mobile";

export default function ToolsView() {
  return <Tools />;
}
